// Normalise API errors into a safe string for toast/UI rendering.
// FastAPI/Pydantic 422 returns `detail` as an array of {type,loc,msg,input,ctx} objects
// which crashes React if rendered directly.
export function errMsg(err, fallback = "Something went wrong") {
  const d = err?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d.map((e) => {
      if (typeof e === "string") return e;
      const loc = Array.isArray(e?.loc) ? e.loc.filter((p) => p !== "body").join(".") : "";
      return loc ? `${loc}: ${e?.msg || "invalid"}` : (e?.msg || "invalid");
    }).join("; ");
  }
  try { return JSON.stringify(d); } catch { return fallback; }
}
